export default __webpack_public_path__ + "static/python-career-banner-7ade667064bc9919d513b836717f1782.jpg";